import Request from '@hotmart/request'
import { EXTENSIONS_REQUEST_IDENTIFIERS } from './extensions-subscriptions.constants'

Request.register(`${process.env.API_PRO}/api/v2`, {
  get: {
    [EXTENSIONS_REQUEST_IDENTIFIERS.GET_EXTENSIONS_SUBSCRIPTIONS]: '/subscription'
  }
})

Request.register(`${process.env.API_PRO}/api/v1`, {
  get: {
    [EXTENSIONS_REQUEST_IDENTIFIERS.GET_EXTENSIONS_SUBSCRIPTION_QUOTA]: '/quota/consumption'
  }
})
